<script lang="ts">
  import { getContext } from 'svelte';
  import { onMount } from 'svelte';
  import './css/timeout.scss';
  import { BulletPoint } from '../../components/index';
  import type { FormDiscount } from '../types';

  export let properties: FormDiscount;
  export let timeOutPopupVisible: boolean;

  const hash = getContext<string>('hash');
  const isEditable = getContext<boolean>('isEditable') || false;

  $: ({
    timeOutCallouts,
    timeOutHeading,
    timeOutSubHeading,
    timeOutButtonText,
    timeOutImage,
  } = properties);

  let visible = false;

  onMount(() => {
    if (!isEditable) {
      document.addEventListener('mouseleave', e => {
        let triggered = sessionStorage.getItem('timeout-popup');
        if (triggered !== 'true') {
          visible = true;
        }
        sessionStorage.setItem('timeout-popup', 'true');
      });
    }
  });

  function handleSubmit(event: Event) {
    properties.submitLead(event);
    visible = false;
  }

  $: isEditable && (visible = timeOutPopupVisible);
</script>

<section class="timeout-popup" class:show-timeout-popup={visible}>
  <div class="blur" />
  <div class="timeout-popup-holder">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <svg
      class="close-timeout-popup"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      on:click={() => (visible = false)}
    >
      <path
        d="M9.01105 22.9901L16.0012 16M16.0012 16L22.9914 9.00977M16.0012 16L9.01105 9.00977M16.0012 16L22.9914 22.9901"
        stroke="#111111"
        stroke-opacity="0.64"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <div class="timeout-popup-left">
      <div class="image">
        <img src={timeOutImage.value} alt="timeOut-img" />
      </div>
    </div>
    <div class="timeout-popup-right">
      <div class="timeout-popup-top">
        <h2 class="h2">WAIT!</h2>
        <h3 class="h3">{@html timeOutHeading.value}</h3>
        <h3 class="h3">
          {@html timeOutSubHeading.value}
        </h3>
      </div>

      <form class="quote-form-inputs" on:submit|preventDefault={handleSubmit}>
        <input type="hidden" name="hash" value={hash} />
        <input type="hidden" name="form_type" value="exit-form" />

        <input
          class="text"
          placeholder="Email address"
          name="email"
          type="email"
        />

        <button id="submit-lead-button" class="primary-button" type="submit"
          >{@html timeOutButtonText.value}</button
        >
        <div class="bottom-boxes">
          <div class="small-text-box">
            {#each timeOutCallouts.value as item}
              <div>
                <BulletPoint bulletIcon={timeOutCallouts?.icon} />
                <p class="text-small">{@html item}</p>
              </div>
            {/each}
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
